import { NativeError } from '@belimo-retrofit-portal/logic';
import { push } from 'redux-first-history';
import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { showNotification } from 'src/modules/notifications/sagas/showNotification';
import { PROJECT_LIST_CLONE } from 'src/modules/project-list/actions/ProjectListActions';
import { copyProject } from 'src/modules/project-list/sagas/utils/copyProject';
import { navigate } from 'src/modules/routing/utils/navigate';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { GetRequestActionType } from 'src/utils/createActions';
import { call, put } from 'typed-redux-saga';

export function* projectListCloneSaga(
  action: GetRequestActionType<typeof PROJECT_LIST_CLONE>,
): SagaIterator<void> {
  const project = action.meta;

  try {
    yield* put(PROJECT_LIST_CLONE.pending(project));
    yield* call(logDebug, 'Clonning project...');

    const copy = yield* call(copyProject, project);

    yield* call(logDebug, 'Clonning project... done', copy);
    yield* put(PROJECT_LIST_CLONE.success(undefined, copy));

    yield* call(navigate, push(`/project/${encodeURIComponent(copy.id)}`));
  } catch (error) {
    yield* call(sentryCatch, error);
    yield* call(showNotification, { variant: 'error', type: 'error' });

    yield* call(logError, 'Clonning project... error', error);
    yield* put(PROJECT_LIST_CLONE.failure(NativeError.wrap(error), project));
  }
}
